import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'user': null,
  'loading': false,
  'error': null,
};

export const wtsAuth = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CREATING_WTS_USER]: (state, action) => ({
      ...state,
      'loading': true,
      'error': null,
    }),
    [ActionTypes.CREATED_WTS_USER]: (state, action) => ({
      ...state,
      'loading': false,
      'user': action.response.data,
      'error': null,
    }),
    [ActionTypes.CREATED_WTS_USER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'user': null,
      'error': action.payload,
    }),
    [ActionTypes.FETCHING_WTS_USER]: (state, action) => ({
      ...state,
      'loading': true,
      'error': null,
    }),
    [ActionTypes.FETCHED_WTS_USER]: (state, action) => ({
      ...state,
      'loading': false,
      'user': action.response.data,
      'error': null,
    }),
    [ActionTypes.FETCHED_WTS_USER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'user': null,
      'error': action.payload,
    }),
    [ActionTypes.UPDATING_WTS_USER]: (state, action) => ({
      ...state,
      'loading': true,
      'error': null,
    }),
    [ActionTypes.UPDATED_WTS_USER]: (state, action) => ({
      ...state,
      'loading': false,
      'user': action.response.data,
      'error': null,
    }),
    [ActionTypes.UPDATED_WTS_USER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'error': action.payload,
    }),
    [ActionTypes.CLEAR_WTS_USER]: (state, action) => ({
      ...state,
      'user': null,
      'error': null,
      'loading': false,
    }),
  })(state, action);
};
